import React, { useContext } from "react";

type CentraContext = {
  token: string | null;
  giftToken: string | null;
  setGiftToken: (token: string) => void;
};

const CentraContext = React.createContext<CentraContext>(null!);

export const useCentraContext = () => {
  const ctx = useContext(CentraContext);
  if (!ctx) {
    throw new Error("useCentraContext must be used within a CentraProvider");
  }
  return ctx;
};

export const useToken = () => useCentraContext().token;

export const useGiftToken = () => useCentraContext().giftToken;
export const useSetGiftToken = () => useCentraContext().setGiftToken;

export default CentraContext;
